"use client";

import { useEffect } from "react";
import { useAppSelector, selectLoginStatus } from "@repo/web-store";

interface DescriptionUtilProps {
  targetId: string;
  hideOnLoggedIn?: boolean;
}

export default function DescriptionUtil({
  targetId,
  hideOnLoggedIn = false,
}: DescriptionUtilProps) {
  const loginStatus = useAppSelector(selectLoginStatus);

  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return;

    if (hideOnLoggedIn && (loginStatus === "success" || loginStatus === "perpetual")) {
      el.classList.add("hidden");
    } else {
      el.classList.remove("hidden");
    }
  }, [loginStatus, hideOnLoggedIn, targetId]);

  return null;
}
